import { FC } from "react";
import { formatTitleFirstWord } from "utils/formatTitle";
import {
  Button,
  ButtonSize,
  ButtonVariant,
  Modal,
  Input,
  InputSize
} from "shared/components";

type Props = {
  opened: boolean;
  onClose: () => void;
  value: string;
  onChange: (value: string) => void;
  fieldName: string;
  onSave: () => void;
};

export const EditModal: FC<Props> = ({
  opened,
  onClose,
  value,
  onChange,
  fieldName,
  onSave
}) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      panelClassName="lg:min-w-[480px] flex flex-col p-6"
    >
      <p className="mb-6 text-xl font-bold text-content-1000">
        {formatTitleFirstWord("Edit " + fieldName)}
      </p>
      <Input
        required
        id={fieldName}
        size={InputSize.BASE}
        label={formatTitleFirstWord(fieldName)}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <div className="flex mt-4 justify-end">
        <Button
          variant={ButtonVariant.PRIMARY}
          size={ButtonSize.BASE}
          onClick={onSave}
          className="w-[125px]"
        >
          Save
        </Button>
      </div>
    </Modal>
  );
};
